module.exports = __webpack_public_path__ + "static/media/paisaje-gris.1b9b2786.svg";